<ion-list [inset]="true" [lines]="showLines ? 'inset' : 'none'" class="bg-transparent" >
  <ion-list-header color="light" *ngIf="!hideTitle">
    <ion-label class="text-lg text-gray-500 mt-5 mb-4">{{ listTitle }}</ion-label>
  </ion-list-header>
  <ng-content></ng-content>
</ion-list>
